import { Link } from "react-router-dom";
import { ExternalLinkIcon } from "lucide-react";
import type { Prd } from "@/types/domain";

const DocNameCell = ({ prd }: { prd: Prd }) => {
  if (!prd) return null;
  // min-w-0 on both: inside a flex row the name must be allowed to shrink
  // below its text width, otherwise phones overflow the row (the 300px cap
  // only bounds it on wide screens).
  return (
    <div className="flex min-w-0 items-center gap-2">
      <span className="min-w-0 max-w-[300px] truncate">{prd.docName}</span>
      {prd.docUrl && (
        <Link to={prd.docUrl} target="_blank" rel="noreferrer">
          <ExternalLinkIcon className="w-4 h-4" />
        </Link>
      )}
    </div>
  );
};

export default DocNameCell;
